export default (props = {}) => <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M5.47656 10.7421L9.87203 3.49219L9.96372 9.87153H14.3755L9.96372 17.0407V10.7421H5.47656Z"/>
</svg>
